/* Pool volume capture, not chemical dosing.
   cc_pool v2 = { schema_version: 2, gallons: integer, updated_at: ISO string }.
   Legacy volumes may prefill the form, but only an explicit save writes v2.
   No dose, product plan, price or delivery cadence is inferred from volume. */
(function () {
  'use strict';
  var PROFILE_KEY = 'cc_pool';

  function volume(value) {
    var raw = String(value == null ? '' : value).trim();
    if (!/^(?:\d+|\d{1,3}(?:,\d{3})+)$/.test(raw)) return null;
    var gallons = Number(raw.replace(/,/g, ''));
    return Number.isSafeInteger(gallons) && gallons >= 1000 && gallons <= 1000000 ? gallons : null;
  }

  function savedVolume() {
    try {
      var profile = JSON.parse(window.localStorage.getItem(PROFILE_KEY) || 'null');
      return profile && volume(profile.gallons);
    } catch (error) { return null; }
  }

  function save(gallons) {
    try {
      window.localStorage.removeItem('cc_pool_tablets');
      window.localStorage.setItem(PROFILE_KEY, JSON.stringify({
        schema_version: 2, gallons: gallons, updated_at: new Date().toISOString()
      }));
      return true;
    } catch (error) { return false; }
  }

  function note(section, gallons) {
    var saved = section.querySelector('[data-calc-saved]');
    if (!saved) return;
    saved.hidden = !gallons;
    var text = saved.querySelector('[data-calc-saved-text]');
    if (text) text.textContent = gallons ? 'Previously entered: ' + gallons.toLocaleString('en-US') + ' gallons. Confirm or change it below.' : '';
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-dosage-calculator]');
    if (!form) return;
    event.preventDefault();
    var section = form.closest('[data-calculator-section]');
    var input = form.querySelector('[name="gallons"]');
    var result = section.querySelector('[data-calculator-result]');
    var error = section.querySelector('[data-calc-error]');
    var gallons = volume(input.value);
    input.setAttribute('aria-invalid', gallons ? 'false' : 'true');
    if (error) error.hidden = !!gallons;
    if (!gallons) {
      if (result) result.classList.remove('is-visible');
      section.removeAttribute('data-calc-gallons');
      return;
    }
    var persisted = save(gallons);
    section.setAttribute('data-calc-gallons', gallons);
    note(section, persisted ? gallons : null);
    if (result) {
      result.querySelector('[data-result-volume]').textContent = gallons.toLocaleString('en-US');
      result.querySelector('[data-result-label]').textContent = persisted ?
        'gallons saved on this device' : 'gallons entered — this browser could not save your volume';
      result.classList.add('is-visible');
    }
    if (persisted) document.dispatchEvent(new CustomEvent('cc:pool-saved', { detail: { gallons: gallons } }));
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-calc-add-to-cart]');
    if (!button) return;
    event.preventDefault();
    var id = Number(button.getAttribute('data-variant-id'));
    if (!Number.isSafeInteger(id) || id <= 0 || !window.CertiClearCart) return;
    var section = button.closest('[data-calculator-section]');
    var gallons = volume(section.getAttribute('data-calc-gallons'));
    var item = { id: id, quantity: 1 };
    if (gallons) item.properties = { '_Pool gallons': String(gallons) };
    var original = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';
    window.CertiClearCart.add([item]).then(function () {
      button.textContent = 'Added ✓';
    }).catch(function () {
      button.textContent = 'Could not confirm. Check your cart before retrying.';
    }).finally(function () {
      button.disabled = false;
      setTimeout(function () { button.textContent = original; }, 2500);
    });
  });

  document.addEventListener('click', function (event) {
    var reset = event.target.closest('[data-calc-reset]');
    if (!reset) return;
    event.preventDefault();
    var section = reset.closest('[data-calculator-section]');
    try {
      window.localStorage.removeItem(PROFILE_KEY);
      window.localStorage.removeItem('cc_pool_tablets');
    } catch (error) { /* Storage can be unavailable. */ }
    note(section, null);
    section.removeAttribute('data-calc-gallons');
    var input = section.querySelector('[name="gallons"]');
    if (input) { input.value = ''; input.setAttribute('aria-invalid', 'false'); input.focus(); }
    var result = section.querySelector('[data-calculator-result]');
    if (result) result.classList.remove('is-visible');
    var errorNote = section.querySelector('[data-calc-error]');
    if (errorNote) errorNote.hidden = true;
    document.dispatchEvent(new CustomEvent('cc:pool-cleared'));
  });

  function init() {
    var gallons = savedVolume();
    if (!gallons) return;
    document.querySelectorAll('[data-calculator-section]').forEach(function (section) {
      var input = section.querySelector('[name="gallons"]');
      if (input && !input.value) input.value = String(gallons);
      note(section, gallons);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
